export default __webpack_public_path__ + "static/media/Kotor.ed54f85d.jpg";